import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { duplicatesLimitCount } from 'reactApp/appHelpers/featuresHelpers/features/duplicates';
import { removeDuplicatesAllStart, removeDuplicatesGroupStart } from 'reactApp/modules/duplicates/duplicates.actions';
import { getDuplicatesRemovedGroupsCount } from 'reactApp/modules/duplicates/duplicates.flags';
import { getDuplicatesLoadedGroupsCount } from 'reactApp/modules/duplicates/duplicates.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { renderDuplicatesRemoveLimitModal } from 'reactApp/ui/Duplicates/DuplicatesRemoveLimitModal/DuplicatesRemoveLimitModal.helpers';
import { renderDuplicatesRemoveLimitWarningModal } from 'reactApp/ui/Duplicates/DuplicatesRemoveLimitWarningModal/DuplicatesRemoveLimitWarningModal.helpers';

export const useDuplicatesRemove = (groupId?: string) => {
    const dispatch = useDispatch();
    const loadedGroupsCount = useSelector(getDuplicatesLoadedGroupsCount);

    const isCorp = useSelector(UserSelectors.isCorpUser);
    const isPaid = useSelector(UserSelectors.isPaidUser);
    const duplicatesLimitEnabled = !isCorp && !isPaid;

    const handleDuplicatesRemoveGroup = useCallback(async () => {
        if (!groupId) {
            return;
        }

        // Удаление одной группы
        if (duplicatesLimitEnabled) {
            const removedGroupsCount = await getDuplicatesRemovedGroupsCount();
            if (removedGroupsCount >= duplicatesLimitCount) {
                // Лимит исчерпан
                renderDuplicatesRemoveLimitModal();
                return;
            }
        }

        dispatch(removeDuplicatesGroupStart({ groupId }));
    }, [dispatch, groupId, duplicatesLimitEnabled]);

    const handleDuplicatesRemoveAll = useCallback(async () => {
        // Полное удаление
        if (duplicatesLimitEnabled) {
            // Проверка лимита
            const removedGroupsCount = await getDuplicatesRemovedGroupsCount();
            if (removedGroupsCount >= duplicatesLimitCount) {
                // Лимит исчерпан
                renderDuplicatesRemoveLimitModal();
                return;
            } else if (removedGroupsCount + loadedGroupsCount > duplicatesLimitCount) {
                // Удаляем с учетом лимита
                renderDuplicatesRemoveLimitWarningModal(duplicatesLimitCount - removedGroupsCount);
                return;
            }
        }

        dispatch(removeDuplicatesAllStart());
    }, [dispatch, loadedGroupsCount, duplicatesLimitEnabled]);

    return { handleDuplicatesRemoveGroup, handleDuplicatesRemoveAll };
};
